import React, { useState, useRef, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAuth, signOut, onAuthStateChanged } from 'firebase/auth';

import { db, storage, getDocs, collection } from '../LoginComp/firebase';
import {
  doc, setDoc, updateDoc, deleteDoc, addDoc, serverTimestamp,
  getDoc, query, where, orderBy,
} from 'firebase/firestore';
import { deleteObject } from 'firebase/storage';
import { createUserWithEmailAndPassword } from 'firebase/auth';
import './consultant.css';



import {
  getStorage,
  ref,
  listAll,
  getDownloadURL,
} from "firebase/storage";



function Consultant() {
  const [selectedOption, setSelectedOption] = useState('viewRecoveryProfile');
  const [openMenu, setOpenMenu] = useState(null);
  const [isLoggingOut, setIsLoggingOut] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();
  const auth = getAuth();

  // ============ LOGGED-IN CONSULTANT ============
  const [currentUser, setCurrentUser] = useState(null);

  // ============ RECOVERY PROFILES STATE ============
  const [vrpProfiles, setVrpProfiles] = useState([]);
  const [vrpLoading, setVrpLoading] = useState(false);
  const [vrpError, setVrpError] = useState('');
  const [vrpSearch, setVrpSearch] = useState('');

  // View modal
  const [viewModal, setViewModal] = useState({ open: false, profile: null });

  // ============ FOLLOW-UP REMINDER STATE ============
  const [showFollowUpModal, setShowFollowUpModal] = useState(false);
  const [selectedFollowUp, setSelectedFollowUp] = useState(null); // { patient, stage }
  const [followUpLanguage, setFollowUpLanguage] = useState('english');
  const [englishFollowUpMsg, setEnglishFollowUpMsg] = useState('');
  const [sinhalaFollowUpMsg, setSinhalaFollowUpMsg] = useState('');


const [profileImages, setProfileImages] = useState({
  firstDay: [],
  xray: [],
});






const loadProfileImages = async (profile) => {
  if (!profile?.id) {
    console.error("❌ Missing profile ID");
    return {
      firstDay: [],
      xray: [],
    };
  }

  const result = {
    firstDay: [],
    xray: [],
  };

  try {
    // =====================================================
    // FIRST DAY PHOTO
    // =====================================================

    const firstDayRef = ref(
      storage,
      `recovery-profile/${profile.id}/firstDayPicture`
    );

    console.log("🏁 FIRST DAY STORAGE PATH:", firstDayRef.fullPath);

    const firstDayResult = await listAll(firstDayRef);

    console.log(
      "🏁 FIRST DAY FILES:",
      firstDayResult.items.map((item) => item.fullPath)
    );

    for (const fileRef of firstDayResult.items) {
      try {
        const url = await getDownloadURL(fileRef);

        console.log("✅ FIRST DAY DOWNLOAD URL:", url);

        result.firstDay.push({
          name: fileRef.name,
          fullPath: fileRef.fullPath,
          displayUrl: url,
        });
      } catch (error) {
        console.error(
          "❌ Could not get First Day URL:",
          fileRef.fullPath,
          error
        );
      }
    }


    // =====================================================
    // X-RAY
    // =====================================================

    const xrayRef = ref(
      storage,
      `recovery-profile/${profile.id}/xrayPhoto`
    );

    console.log("🩻 XRAY STORAGE PATH:", xrayRef.fullPath);

    const xrayResult = await listAll(xrayRef);

    console.log(
      "🩻 XRAY FILES:",
      xrayResult.items.map((item) => item.fullPath)
    );

    for (const fileRef of xrayResult.items) {
      try {
        const url = await getDownloadURL(fileRef);

        result.xray.push({
          name: fileRef.name,
          fullPath: fileRef.fullPath,
          displayUrl: url,
        });
      } catch (error) {
        console.error(
          "❌ Could not get X-Ray URL:",
          fileRef.fullPath,
          error
        );
      }
    }

  } catch (error) {
    console.error("🔥 STORAGE ERROR:", error);
    console.error("CODE:", error?.code);
    console.error("MESSAGE:", error?.message);
  }

  console.log("📸 FINAL FIRST DAY:", result.firstDay);
  console.log("🩻 FINAL XRAY:", result.xray);

  return result;
};









  // ============ UTILITIES ============
  const toDate = (value) => {
    if (!value) return null;
    if (typeof value?.toDate === 'function') return value.toDate();
    if (typeof value === 'object' && 'seconds' in value) return new Date(value.seconds * 1000);
    if (typeof value === 'string' && /^\d{4}-\d{1,2}-\d{1,2}$/.test(value)) {
      const [y, m, d] = value.split('-');
      const dt = new Date(`${y}-${m.padStart(2, '0')}-${d.padStart(2, '0')}`);
      return isNaN(dt.getTime()) ? null : dt;
    }
    const dt = new Date(value);
    return isNaN(dt.getTime()) ? null : dt;
  };

  const getDaysUntil = (dateStr) => {
    const target = toDate(dateStr);
    if (!target) return 999;
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    target.setHours(0, 0, 0, 0);
    return Math.round((target - today) / (1000 * 60 * 60 * 24));
  };

  const formatFollowUpDate = (dateStr) => {
    const d = toDate(dateStr);
    if (!d) return '—';
    return d.toLocaleDateString('en-GB', {
      day: '2-digit', month: 'long', year: 'numeric',
    });
  };

  // Read the follow-up date from a stage — handles BOTH spellings
  const getStageNextDate = (stage) => {
    if (!stage) return null;
    return stage.nextFollowUpDate || stage.nextfollowUpDate || null;
  };

  const prettyCondition = (c) =>
    c ? c.replace(/-/g, ' ').replace(/\b\w/g, (x) => x.toUpperCase()) : '—';

  // ============ CLOSE DROPDOWN ON OUTSIDE CLICK ============
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpenMenu(null);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  const handleSelect = (option) => {
    setSelectedOption(option);
    setOpenMenu(null);
  };

  const toggleDropdown = (menu) => setOpenMenu(openMenu === menu ? null : menu);

  const handleLogout = async () => {
    try {
      setIsLoggingOut(true);
      setOpenMenu(null);
      await signOut(auth);
      localStorage.removeItem('user');
      localStorage.removeItem('userRole');
      sessionStorage.clear();
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
      alert('Error logging out. Please try again.');
      setIsLoggingOut(false);
    }
  };

  // ============ RESOLVE LOGGED-IN CONSULTANT ============
  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (user) => {
      if (!user) return setCurrentUser(null);
      try {
        const q = query(collection(db, 'users'), where('email', '==', user.email));
        const snap = await getDocs(q);
        if (!snap.empty) {
          const d = snap.docs[0];
          setCurrentUser({ uid: user.uid, docId: d.id, ...d.data() });
        } else {
          setCurrentUser({ uid: user.uid, email: user.email });
        }
      } catch (e) {
        console.error('resolve user error:', e);
      }
    });
    return () => unsub();
  }, [auth]);

  // ============ FETCH ONLY THIS CONSULTANT'S PROFILES ============
  const fetchRecoveryProfiles = async () => {
    if (!currentUser) return;
    setVrpLoading(true);
    setVrpError('');

    try {
      const col = collection(db, 'recovery-profile'); // ✅ correct collection name
      let merged = [];

      // ---- Query 1: by assignedConsultantId ----
      const consultantId = currentUser.docId || currentUser.uid;
      if (consultantId) {
        const q1 = query(col, where('assignedConsultantId', '==', consultantId));
        const s1 = await getDocs(q1);
        merged = s1.docs.map((d) => ({ id: d.id, ...d.data() }));
      }

      // ---- Query 2: by assignedConsultantEmail (fallback) ----
      if (currentUser.email) {
        const q2 = query(
          col,
          where('assignedConsultantEmail', '==', currentUser.email)
        );
        const s2 = await getDocs(q2);
        const byEmail = s2.docs.map((d) => ({ id: d.id, ...d.data() }));

        const seen = new Set(merged.map((p) => p.id));
        byEmail.forEach((p) => {
          if (!seen.has(p.id)) merged.push(p);
        });
      }

      console.log('📦 profiles for consultant:', merged.length);
      setVrpProfiles(merged);
    } catch (e) {
      console.error('❌ fetch profiles error:', e);
      setVrpError('Failed to load recovery profiles: ' + e.message);
    } finally {
      setVrpLoading(false);
    }
  };

  useEffect(() => {
    if (currentUser) fetchRecoveryProfiles();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentUser]);

  // ============ FILTER ============
  const vrpFiltered = vrpProfiles.filter((p) => {
    const q = vrpSearch.toLowerCase();
    const stageMatch = (p.stages || []).some((s) =>
      (s.stageName || '').toLowerCase().includes(q)
    );
    return (
      (p.patientName || '').toLowerCase().includes(q) ||
      (p.patientPhone || '').toLowerCase().includes(q) ||
      (p.condition || '').toLowerCase().includes(q) ||
      (p.assignedConsultant || '').toLowerCase().includes(q) ||
      stageMatch
    );
  });

 





const openViewModal = async (profile) => {
  console.log("👤 OPENING PROFILE:", profile.id);

  setViewModal({
    open: true,
    profile,
  });

  setProfileImages({
    firstDay: [],
    xray: [],
  });

  const images = await loadProfileImages(profile);

  console.log("🎯 LOADED IMAGES:", images);

  setProfileImages(images);
};







  // ============ SEND VIA WHATSAPP ============
  const sendFollowUpWhatsApp = (patient, language) => {
    const phone = (patient.patientPhone || '').replace(/\D/g, '');
    if (!phone) { alert('❌ No phone number available for this patient'); return; }
    const intlPhone = phone.startsWith('0') ? '94' + phone.substring(1) : phone;
    const message = language === 'english' ? englishFollowUpMsg : sinhalaFollowUpMsg;
    window.open(`https://wa.me/${intlPhone}?text=${encodeURIComponent(message)}`, '_blank');
  };

  // ============ SEND VIA SMS ============
  const sendFollowUpSMS = (patient, language) => {
    const phone = (patient.patientPhone || '').replace(/\D/g, '');
    if (!phone) { alert('❌ No phone number available for this patient'); return; }
    const message = language === 'english' ? englishFollowUpMsg : sinhalaFollowUpMsg;
    window.location.href = `sms:${phone}?body=${encodeURIComponent(message)}`;
  };

  // ============ NATIVE CALL ============
  const callPatient = (patient) => {
    const phone = (patient.patientPhone || '').replace(/\D/g, '');
    if (!phone) { alert('❌ No phone number available'); return; }
    window.location.href = `tel:${phone}`;
  };







  // ============ FULL-SIZE IMAGE VIEWER ============
const [imageViewer, setImageViewer] = useState({
  open: false,
  url: "",
  title: "",
});




// ============================================================
// IMAGE HELPERS
// Supports Firebase Storage URLs + old dataUrl format
// ============================================================

const getPhotoUrl = (photo) => {
  if (!photo) return "";

  if (typeof photo === "string") return photo;

  return (
    photo.url ||
    photo.downloadURL ||
    photo.dataUrl ||
    photo.src ||
    ""
  );
};







// ============================================================
// IMAGE HELPERS
// ============================================================

const getImageUrl = (photo) => {
  if (!photo) return "";

  // Firebase Storage / normal URL formats
  return (
    photo.displayUrl ||
    photo.downloadURL ||
    photo.downloadUrl ||
    photo.url ||
    photo.dataUrl ||
    ""
  );
};

const getStagePhotos = (stage) => {
  if (!stage) return [];

  const photos = Array.isArray(stage.photos) ? stage.photos : [];

  return photos
    .map((photo) => ({
      ...photo,
      displayUrl: getImageUrl(photo),
    }))
    .filter((photo) => photo.displayUrl);
};

const getProfileFirstDayPhotos = (profile) => {
  if (!profile) return [];

  const photos =
    profile.firstDayPicture ||
    profile.firstDayPhotos ||
    profile.firstDayPhoto ||
    profile.firstDayImage ||
    [];

  // Single URL/path string
  if (typeof photos === "string") {
    return photos
      ? [{
          displayUrl: photos,
          storagePath: photos,
        }]
      : [];
  }

  if (!Array.isArray(photos)) return [];

  return photos
    .map((photo) => {
      if (typeof photo === "string") {
        return {
          displayUrl: photo,
          storagePath: photo,
        };
      }

      return {
        ...photo,
        displayUrl:
          photo.displayUrl ||
          photo.url ||
          photo.downloadURL ||
          photo.downloadUrl ||
          photo.imageUrl ||
          photo.fileUrl ||
          getImageUrl(photo),
      };
    })
    .filter((photo) => photo.displayUrl);
};


const getProfileXrayPhotos = (profile) => {
  if (!profile) return [];

  // Supports multiple possible Firebase field names
  const photos =
    profile.xrayPhotos ||
    profile.xRayPhotos ||
    profile.xrayPhoto ||
    profile.xRayPhoto ||
    profile.xrayImages ||
    [];

  // If a single URL was saved
  if (typeof photos === "string") {
    return photos ? [{ displayUrl: photos }] : [];
  }

  if (!Array.isArray(photos)) return [];

  return photos
    .map((photo) => ({
      ...photo,
      displayUrl: getImageUrl(photo),
    }))
    .filter((photo) => photo.displayUrl);
};





const loadFirstDayPhotos = async (profile) => {
  if (!profile?.id) return [];

  try {
    const folderRef = ref(
      storage,
      `recovery-profile/${profile.id}/firstDayPicture`
    );

    const result = await listAll(folderRef);

    const photos = await Promise.all(
      result.items.map(async (fileRef) => {
        const url = await getDownloadURL(fileRef);

        return {
          displayUrl: url,
          storagePath: fileRef.fullPath,
          name: fileRef.name,
        };
      })
    );

    console.log("🏁 First Day Photos:", photos);

    return photos;
  } catch (error) {
    console.error("❌ First Day image loading error:", error);
    return [];
  }
};








const openFullImage = (url, title = "Recovery Image") => {
  if (!url) return;

  setImageViewer({
    open: true,
    url,
    title,
  });
};

const closeFullImage = () => {
  setImageViewer({
    open: false,
    url: "",
    title: "",
  });
};



  return (
    <>
      {/* TOP NAVIGATION BAR */}
      {/* <nav className="top-nav" ref={dropdownRef}>
        <div className="logo">Powered By Glaxmore IT</div>

        <ul className="nav-links">
          <li
            className={`nav-single-btn ${selectedOption === 'viewRecoveryProfile' ? 'active-nav' : ''}`}
            onClick={() => handleSelect('viewRecoveryProfile')}
          >
            <span className="dropdown-label"> View Recovery Profiles</span>
          </li>

          <li
            className={`logout-btn ${isLoggingOut ? 'logging-out' : ''}`}
            onClick={(e) => { e.stopPropagation(); handleLogout(); }}
          >
            {isLoggingOut ? 'Logging out...' : 'Logout'}
          </li>
        </ul>
      </nav> */}





<nav className="top-nav" ref={dropdownRef}>
  <div className="logo">Powered By Glaxmore IT</div>

  <ul className="nav-links">
    {/* 👋 Greeting */}
    {currentUser && (
      <li className="nav-greeting">
        👋 Hello,{' '}
        <strong>
          {currentUser.firstName || ''} {currentUser.lastName || ''}
        </strong>

      </li>
    )}

    <li
      className={`nav-single-btn ${selectedOption === 'viewRecoveryProfile' ? 'active-nav' : ''}`}
      onClick={() => handleSelect('viewRecoveryProfile')}
    >
      <span className="dropdown-label"> View Recovery Profiles</span>
    </li>

    <li
      className={`logout-btn ${isLoggingOut ? 'logging-out' : ''}`}
      onClick={(e) => { e.stopPropagation(); handleLogout(); }}
    >
      {isLoggingOut ? 'Logging out...' : 'Logout'}
    </li>
  </ul>
</nav>





      {/* PAGE BODY */}
      <div className="page-body">

 {/************************************* VIEW RECOVERY PROFILES *********************************************/}


        {selectedOption === 'viewRecoveryProfile' && (
          <div className="View-Recovery-Profile-wrapper">
            <h1 className="View-Recovery-Profile-title">📋 View Recovery Profile</h1>

            <div className="vrp-toolbar">
              <input
                type="text"
                className="vrp-search-input"
                placeholder="🔍 Search by patient name, phone, or stage..."
                value={vrpSearch}
                onChange={(e) => setVrpSearch(e.target.value)}
              />
              <button className="vrp-refresh-btn" onClick={fetchRecoveryProfiles}>
                🔄 Refresh
              </button>
            </div>

            <div className="vrp-stats">
              My Assigned Profiles: <strong>{vrpFiltered.length}</strong>
            </div>

            {vrpLoading && <p className="vrp-loading">Loading recovery profiles...</p>}
            {vrpError && <p className="vrp-error">⚠️ {vrpError}</p>}

            {!vrpLoading && !vrpError && (
              <div className="vrp-table-wrapper">
                <table className="vrp-table">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Patient</th>
                      <th>Phone</th>
                      <th>Condition</th>
                      <th>Follow-Up(s)</th>
                      <th>Start Date</th>
                      <th>Next Follow-Up</th>
                      <th>Consultant</th>
                    </tr>
                  </thead>
                  <tbody>
                    {vrpFiltered.length === 0 ? (
                      <tr>
                        <td colSpan="8" className="vrp-empty">
                          <span style={{ fontSize: '38px' }}>📭</span>
                          <p>No recovery profiles assigned to you</p>
                        </td>
                      </tr>
                    ) : (
                      vrpFiltered.map((profile, index) => (
                        <tr
                          key={profile.id}
                          onClick={() => openViewModal(profile)}
                          style={{ cursor: 'pointer' }}
                        >
                          <td>{index + 1}</td>
                          <td><strong>{profile.patientName || '—'}</strong></td>
                          <td>{profile.patientPhone || '—'}</td>
                          <td>{prettyCondition(profile.condition)}</td>
                          <td>
                            {(profile.stages || []).length === 0 ? (
                              <span>—</span>
                            ) : (
                              (profile.stages || []).map((s, i) => (
                                <span
                                  key={i}
                                  className="vrp-stage-badge"
                                  style={{ marginRight: 4 }}
                                >
                                  {s.stageName || 'N/A'}
                                </span>
                              ))
                            )}
                          </td>
                          <td>{profile.recoveryStartDate || '—'}</td>
                          <td>
                            {(profile.stages || []).length === 0
                              ? (profile.nextFollowUp || '—')
                              : ((profile.stages || [])
                                  .map((s) => getStageNextDate(s))
                                  .filter(Boolean)
                                  .join(' • ') || profile.nextFollowUp || '—')}
                          </td>
                          <td>{profile.assignedConsultant || '—'}</td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            )}

            {/* ============================= VIEW MODAL ============================= */}
            {viewModal.open && viewModal.profile && (
              <div
                className="vrp-modal-overlay"
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    setViewModal({ open: false, profile: null });
                  }
                }}
              >
                <div className="vrp-modal-content vrp-modal-lg">
                  <div className="vrp-modal-header">
                    <h3>👁️ Recovery Profile — {viewModal.profile.patientName}</h3>
                    <button
                      className="vrp-modal-close"
                      onClick={() => setViewModal({ open: false, profile: null })}
                    >
                      ×
                    </button>
                  </div>

                  <div className="vrp-modal-body">
                    {/* ---------- PATIENT BASIC INFO ---------- */}
                    <div className="vrp-detail-grid">
                    
                      <div><strong>Patient Name:</strong> {viewModal.profile.patientName || '—'}</div>
                      <div><strong>Gender:</strong> {viewModal.profile.patientGender || '—'}</div>
                      <div><strong>DOB:</strong> {viewModal.profile.patientDob || '—'}</div>
                      <div><strong>Phone:</strong> {viewModal.profile.patientPhone || '—'}</div>
                      <div><strong>Email:</strong> {viewModal.profile.patientEmail || '—'}</div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <strong>Address:</strong> {viewModal.profile.patientAddress || '—'}
                      </div>
                    </div>





{/* ============================================================
    PROFILE IMAGES
============================================================ */}
<div className="vrp-section" style={{ marginTop: "20px" }}>
  <h4 className="vrp-section-title">
    📸 Recovery Profile Images
  </h4>

  <div
    style={{
      display: "grid",
      gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
      gap: "20px",
      marginTop: "15px",
    }}
  >






<div
  style={{
    border: "1px solid #ddd",
    borderRadius: "12px",
    padding: "14px",
    background: "#fff",
  }}
>
  <h5
    style={{
      margin: "0 0 12px",
      fontSize: "16px",
      color: "#333",
    }}
  >
    🏁 First Day Photo
  </h5>

  {profileImages.firstDay &&
  profileImages.firstDay.length > 0 ? (
    <div>
      <div
        onClick={() =>
          openFullImage(
            profileImages.firstDay[0].displayUrl,
            "First Day Photo"
          )
        }
        style={{
          width: "100%",
          height: "220px",
          borderRadius: "10px",
          overflow: "hidden",
          cursor: "pointer",
          background: "#f5f5f5",
          border: "1px solid #ddd",
        }}
      >
        <img
          src={profileImages.firstDay[0].displayUrl}
          alt="First Day Photo"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "contain",
            display: "block",
          }}
          onLoad={() => {
            console.log(
              "✅ FIRST DAY IMAGE DISPLAYED:",
              profileImages.firstDay[0].displayUrl
            );
          }}
          onError={(e) => {
            console.error(
              "❌ FIRST DAY IMAGE FAILED:",
              profileImages.firstDay[0].displayUrl
            );

            console.error(
              "Image element:",
              e.currentTarget
            );
          }}
        />
      </div>

      {profileImages.firstDay.length > 1 && (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(5, 1fr)",
            gap: "6px",
            marginTop: "8px",
          }}
        >
          {profileImages.firstDay
            .slice(1)
            .map((photo, index) => (
              <div
                key={photo.fullPath || index}
                onClick={() =>
                  openFullImage(
                    photo.displayUrl,
                    `First Day Photo ${index + 2}`
                  )
                }
                style={{
                  height: "60px",
                  borderRadius: "6px",
                  overflow: "hidden",
                  cursor: "pointer",
                  border: "1px solid #ddd",
                  background: "#f5f5f5",
                }}
              >
                <img
                  src={photo.displayUrl}
                  alt={`First Day ${index + 2}`}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                  }}
                />
              </div>
            ))}
        </div>
      )}
    </div>
  ) : (
    <div
      style={{
        height: "220px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        background: "#f8f8f8",
        borderRadius: "10px",
        color: "#999",
      }}
    >
      📭 No First Day Photo
    </div>
  )}
</div>







    {/* ========================================================
        X-RAY PHOTO
    ======================================================== */}
    <div
      style={{
        border: "1px solid #ddd",
        borderRadius: "12px",
        padding: "14px",
        background: "#fff",
      }}
    >
      <h5
        style={{
          margin: "0 0 12px",
          fontSize: "16px",
          color: "#333",
        }}
      >
        🩻 X-Ray Photo
      </h5>

      {(() => {
        const photos = getProfileXrayPhotos(viewModal.profile);
        const firstPhoto = photos[0];

        return firstPhoto ? (
          <div>
            <div
              onClick={() =>
                openFullImage(
                  firstPhoto.displayUrl,
                  "X-Ray Photo"
                )
              }
              style={{
                width: "100%",
                height: "220px",
                borderRadius: "10px",
                overflow: "hidden",
                cursor: "pointer",
                background: "#111",
                border: "1px solid #ddd",
              }}
              title="Click to view full size"
            >
              <img
                src={firstPhoto.displayUrl}
                alt="X-Ray"
                style={{
                  width: "100%",
                  height: "100%",
                  objectFit: "contain",
                  display: "block",
                }}
              />
            </div>

            {photos.length > 1 && (
              <div
                style={{
                  marginTop: "8px",
                  fontSize: "13px",
                  color: "#666",
                }}
              >
                +{photos.length - 1} more image
                {photos.length - 1 > 1 ? "s" : ""}
              </div>
            )}
          </div>
        ) : (
          <div
            style={{
              height: "220px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              background: "#f8f8f8",
              borderRadius: "10px",
              color: "#999",
            }}
          >
            🩻 No X-Ray Photo
          </div>
        );
      })()}
    </div>
  </div>
</div>

<hr />




                    <hr />

                    {/* ---------- CLINICAL INFO ---------- */}
                    <div className="vrp-detail-grid">
                      <div><strong>Condition:</strong> {prettyCondition(viewModal.profile.condition)}</div>
                      <div><strong>Start Height:</strong> {viewModal.profile.height || '—'}</div>
                      <div><strong>Start Weight:</strong> {viewModal.profile.weight || '—'}</div>
                      <div><strong>Menarche:</strong> {viewModal.profile.menarche || '—'}</div>
                      <div><strong>Recovery Start:</strong> {viewModal.profile.recoveryStartDate || '—'}</div>
                      <div><strong>Next Follow-Up:</strong> {viewModal.profile.nextFollowUp || '—'}</div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <strong>Treatment Plan:</strong> {viewModal.profile.treatmentPlan || '—'}
                      </div>
                      <div style={{ gridColumn: '1 / -1' }}>
                        <strong>Remarks:</strong> {viewModal.profile.remarks || '—'}
                      </div>
                    </div>

                    <hr />

                    {/* ---------- ASSIGNED CONSULTANT ---------- */}
                    <div className="vrp-detail-grid">
                      <div><strong>Consultant:</strong> {viewModal.profile.assignedConsultant || '—'}</div>
                      <div><strong>Email:</strong> {viewModal.profile.assignedConsultantEmail || '—'}</div>
                      <div><strong>Specialization:</strong> {viewModal.profile.assignedConsultantSpecialization || '—'}</div>
                    </div>

                    <hr />

                    {/* ---------- STAGES TABLE ---------- */}
                    <h4 style={{ marginTop: 12 }}>🩺 Recovery Stages</h4>

                    {(viewModal.profile.stages || []).length === 0 ? (
                      <p className="vrp-empty-text">No stages recorded yet.</p>
                    ) : (
                      <div className="vrp-table-wrapper">
                        <table className="vrp-table">
                          <thead>
                            <tr>
                              <th>#</th>
                              <th>Follow-Up</th>
                              <th>Followed Date</th>
                              <th>Next Follow-Up</th>
                              <th>Height</th>
                              <th>Weight</th>
                              <th>Notes</th>
                              <th>Images</th>
                            </tr>
                          </thead>

                          <tbody>
                            {(viewModal.profile.stages || []).map((stage, i) => {
                              const nextDate = getStageNextDate(stage);
                              const stagePhotos = getStagePhotos(stage);

                              // First image = summary image
                              const firstPhoto = stagePhotos[0];

                              return (
                                <tr key={i}>
                                  <td>{i + 1}</td>

                                  <td>
                                    <strong>{stage.stageName || "N/A"}</strong>
                                  </td>

                                  <td>
                                    {stage.followUpDate || "—"}
                                  </td>

                                  <td>
                                    {formatFollowUpDate(nextDate)}
                                  </td>

                                  <td>
                                    {stage.followupheight || stage.height || "—"}
                                  </td>

                                  <td>
                                    {stage.followupweight || "—"}
                                  </td>

                                  <td>
                                    {stage.notes || "—"}
                                  </td>

                                  {/* IMAGE SUMMARY */}
                                  <td>
                                    {stagePhotos.length > 0 ? (
                                      <div
                                        onClick={(e) => {
                                          e.stopPropagation();

                                          openFullImage(
                                            stagePhotos[0].displayUrl,
                                            `${stage.stageName || `Follow-Up ${i + 1}`} - Image 1`
                                          );
                                        }}
                                        style={{
                                          width: "65px",
                                          height: "65px",
                                          borderRadius: "8px",
                                          overflow: "hidden",
                                          border: "2px solid #ddd",
                                          cursor: "pointer",
                                          background: "#f5f5f5",
                                        }}
                                        title="Click to view full size"
                                      >
                                        <img
                                          src={stagePhotos[0].displayUrl}
                                          alt="Follow-Up"
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block",
                                          }}
                                        />
                                      </div>
                                    ) : (
                                      <span style={{ color: "#999" }}>
                                        No image
                                      </span>
                                    )}
                                  </td>

                                </tr>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}


                  {/* ============================================================
                      FOLLOW-UP IMAGE SUMMARY / GALLERY
                  ============================================================ */}

                    <div className="vrp-section" style={{ marginTop: "20px" }}>
                      <h4 className="vrp-section-title">
                        🖼️ Follow-Up Images
                      </h4>

                      {(viewModal.profile.stages || []).every(
                        (stage) => getStagePhotos(stage).length === 0
                      ) ? (
                        <p className="vrp-no-stages">
                          No images uploaded for this recovery profile.
                        </p>
                      ) : (
                        <div
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(auto-fill, minmax(240px, 1fr))",
                            gap: "18px",
                          }}
                        >
                          {(viewModal.profile.stages || []).map((stage, sIdx) => {
                            const photos = getStagePhotos(stage);

                            if (photos.length === 0) return null;

                            return (
                              <div
                                key={sIdx}
                                style={{
                                  border: "1px solid #ddd",
                                  borderRadius: "12px",
                                  padding: "12px",
                                  background: "#fff",
                                  boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
                                }}
                              >
                                {/* HEADER */}
                                <div
                                  style={{
                                    display: "flex",
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                    marginBottom: "10px",
                                  }}
                                >
                                  <strong>
                                    🩺 {stage.stageName || `Follow-Up ${sIdx + 1}`}
                                  </strong>

                                  <span
                                    style={{
                                      fontSize: "12px",
                                      color: "#666",
                                      background: "#f1f5f9",
                                      padding: "4px 8px",
                                      borderRadius: "10px",
                                    }}
                                  >
                                    {photos.length} image{photos.length > 1 ? "s" : ""}
                                  </span>
                                </div>

                                {/* MAIN SUMMARY IMAGE */}
                                <div
                                  onClick={() =>
                                    openFullImage(
                                      photos[0].displayUrl,
                                      `${stage.stageName || `Follow-Up ${sIdx + 1}`} - Image 1`
                                    )
                                  }
                                  style={{
                                    width: "100%",
                                    height: "190px",
                                    borderRadius: "10px",
                                    overflow: "hidden",
                                    cursor: "pointer",
                                    background: "#f4f4f4",
                                    border: "1px solid #ddd",
                                  }}
                                  title="Click to view full size"
                                >
                                  <img
                                    src={photos[0].displayUrl}
                                    alt={`${stage.stageName || "Follow-Up"} main`}
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "contain",
                                      display: "block",
                                    }}
                                  />
                                </div>

                                {/* OTHER THUMBNAILS */}
                                {photos.length > 1 && (
                                  <div
                                    style={{
                                      display: "grid",
                                      gridTemplateColumns: "repeat(4, 1fr)",
                                      gap: "6px",
                                      marginTop: "8px",
                                    }}
                                  >
                                    {photos.slice(1).map((photo, pIdx) => (
                                      <div
                                        key={pIdx}
                                        onClick={() =>
                                          openFullImage(
                                            photo.displayUrl,
                                            `${stage.stageName || `Follow-Up ${sIdx + 1}`} - Image ${
                                              pIdx + 2
                                            }`
                                          )
                                        }
                                        style={{
                                          height: "60px",
                                          borderRadius: "6px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          border: "1px solid #ddd",
                                          background: "#f5f5f5",
                                        }}
                                        title="Click to view full size"
                                      >
                                        <img
                                          src={photo.displayUrl}
                                          alt={`Follow-Up ${sIdx + 1} image ${pIdx + 2}`}
                                          style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                            display: "block",
                                          }}
                                        />
                                      </div>
                                    ))}
                                  </div>
                                )}
                              </div>
                            );
                          })}
                        </div>
                      )}
                    </div>




                    {/* ============================================================
                        FULL-SIZE IMAGE VIEWER
                    ============================================================ */}
                    {imageViewer.open && imageViewer.url && (
                      <div
                        style={{
                          position: "fixed",
                          inset: 0,
                          background: "rgba(0, 0, 0, 0.92)",
                          zIndex: 999999,
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          padding: "20px",
                        }}
                        onClick={closeFullImage}
                      >
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          {/* HEADER */}
                          <div
                            style={{
                              position: "absolute",
                              top: "0",
                              left: "0",
                              right: "0",
                              display: "flex",
                              justifyContent: "space-between",
                              alignItems: "center",
                              padding: "10px 15px",
                              color: "#fff",
                              zIndex: 5,
                            }}
                          >
                            <strong
                              style={{
                                fontSize: "18px",
                              }}
                            >
                              🖼️ {imageViewer.title}
                            </strong>

                            <button
                              type="button"
                              onClick={closeFullImage}
                              style={{
                                width: "44px",
                                height: "44px",
                                borderRadius: "50%",
                                border: "none",
                                background: "rgba(255,255,255,0.18)",
                                color: "#fff",
                                fontSize: "30px",
                                cursor: "pointer",
                              }}
                            >
                              ×
                            </button>
                          </div>

                          {/* IMAGE */}
                          <img
                            src={imageViewer.url}
                            alt={imageViewer.title}
                            style={{
                              maxWidth: "95vw",
                              maxHeight: "90vh",
                              width: "auto",
                              height: "auto",
                              objectFit: "contain",
                              borderRadius: "8px",
                              boxShadow: "0 10px 50px rgba(0,0,0,0.6)",
                            }}
                          />

                          <div
                            style={{
                              position: "absolute",
                              bottom: "12px",
                              color: "#ddd",
                              fontSize: "13px",
                            }}
                          >
                            Click outside or × to close
                          </div>
                        </div>
                      </div>
                    )}



                  </div>

                  <div className="vrp-modal-footer">
                    <button
                      className="vrp-btn vrp-btn-gray"
                      onClick={() => setViewModal({ open: false, profile: null })}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}

            {/* ============================= FOLLOW-UP REMINDER MODAL ============================= */}
            {showFollowUpModal && selectedFollowUp && (
              <div
                className="modal-overlay"
                onClick={(e) => {
                  if (e.target === e.currentTarget) {
                    setShowFollowUpModal(false);
                    setSelectedFollowUp(null);
                  }
                }}
              >
                <div className="modal-content birthday-modal">
                  <div className="modal-header">
                    <h3>
                      📋 Follow-up Reminder — {selectedFollowUp.patient.patientName}{' '}
                      ({selectedFollowUp.stage.stageName || 'N/A'})
                    </h3>
                    <button
                      className="modal-close"
                      onClick={() => {
                        setShowFollowUpModal(false);
                        setSelectedFollowUp(null);
                      }}
                    >
                      ×
                    </button>
                  </div>

                  <div className="lang-tabs">
                    <button
                      className={`lang-tab ${followUpLanguage === 'english' ? 'active' : ''}`}
                      onClick={() => setFollowUpLanguage('english')}
                    >
                      🇬🇧 English
                    </button>
                    <button
                      className={`lang-tab ${followUpLanguage === 'sinhala' ? 'active' : ''}`}
                      onClick={() => setFollowUpLanguage('sinhala')}
                    >
                      🇱🇰 සිංහල
                    </button>
                  </div>

                  <div className="message-preview">
                    <label>Message Preview:</label>
                    <textarea
                      className="birthday-textarea"
                      value={followUpLanguage === 'english' ? englishFollowUpMsg : sinhalaFollowUpMsg}
                      onChange={(e) => {
                        if (followUpLanguage === 'english') setEnglishFollowUpMsg(e.target.value);
                        else setSinhalaFollowUpMsg(e.target.value);
                      }}
                      rows="8"
                    />
                  </div>

                  <div className="send-options">
                    <h4>Send via:</h4>
                    <div className="send-buttons">
                      <button
                        className="btn-whatsapp"
                        onClick={() => sendFollowUpWhatsApp(selectedFollowUp.patient, followUpLanguage)}
                      >
                        💬 WhatsApp
                      </button>
                      <button
                        className="btn-sms"
                        onClick={() => sendFollowUpSMS(selectedFollowUp.patient, followUpLanguage)}
                      >
                        📱 SMS
                      </button>
                      <button
                        className="btn-call"
                        onClick={() => callPatient(selectedFollowUp.patient)}
                      >
                        📞 Call
                      </button>
                      <button
                        className="btn-copy"
                        onClick={() => {
                          const text = followUpLanguage === 'english' ? englishFollowUpMsg : sinhalaFollowUpMsg;
                          navigator.clipboard.writeText(text);
                          alert('✅ Message copied to clipboard!');
                        }}
                      >
                        📋 Copy
                      </button>
                    </div>
                  </div>

                  <div className="form-actions">
                    <button
                      type="button"
                      className="btn-cancel"
                      onClick={() => {
                        setShowFollowUpModal(false);
                        setSelectedFollowUp(null);
                      }}
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        )}



      </div>
    </>
  );
}

export default Consultant;